import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import * as confirmationDialogModel from '../../../typings/models/confirmation-dialog.model';
import {COMMON_CONSTANTS} from '../../../core/constants/common.constants';

@Component({
  standalone: true,
  selector: 'app-confirmation-dialog',
  imports: [],
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: confirmationDialogModel.ConfirmationDialogModel,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) {
  }

  cancelText = () => this.data.cancelText || COMMON_CONSTANTS.CANCEL;
  confirmationText = () => this.data.confirmText || COMMON_CONSTANTS.CONFIRM;

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
